import React, {ReactNode} from 'react';
import DataItemSelect from './DataItemSelect';

export default DataItemSelect;

interface DataItemSelectProps {
  fieldId: string,
  placeholder: ReactNode,
  options: {value: number, label: string}[],
  customStyles: {[p: string]: unknown},
  containerStyle: string,
  labelStyle: string,
  inputContainerStyle: string,
  label: ReactNode
}

export const TypedDataItemSelect = DataItemSelect as unknown as React.FC<DataItemSelectProps>;